import { CheckUserPayload, OtpRequiredResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const checkUser = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: CheckUserPayload
}): Promise<AxiosResponse<OtpRequiredResponse | void>> => {
  return api.post<OtpRequiredResponse | void>('/user/check', params)
}
